<template>
    <v-app id="inspire">
      <template v-if="$route.path.includes('login') || $route.path.includes('access-teacher') || $route.path.includes('login/teacher')">
        <LoginTeacher v-if="$route.path.includes('login/teacher')" />
        <AccessTeacher v-else-if="$route.path.includes('access-teacher')" />
        <LoginEmail v-else-if="$route.path.includes('login')" />
      </template>
      <SysCoreMaster v-else/>
    </v-app>
</template>
<script>

import LoginEmail from "./domains/access/login/components/Login.vue";
import AccessTeacher from "./modules/auth/teacher/pages/Access.vue";
import LoginTeacher from "./modules/auth/teacher/pages/Index.vue";
import ptMessages from "devextreme/localization/messages/pt.json";
import { locale, loadMessages } from "devextreme/localization";

export default {
  name: "App",
  components: {
    AccessTeacher,
    LoginTeacher,
    LoginEmail
  },
  created() {
    loadMessages(ptMessages);
    locale(navigator.language);
  }
}
</script>

<style>

.custom-placeholder input::placeholder {
  font-size: 12px !important;
  color: gray   !important;
}


</style>